import {useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';
import {useToast} from 'react-native-toast-notifications';
import {useModal} from 'extensions/viewport/useModal';
import {Prompt} from 'interface/base/Prompt';
import {password} from 'utils/mediafire';

export function useModalPassword(id: string, name: string, isFolder: boolean) {
  const {t} = useLingui();
  const modal = useModal();
  const toast = useToast();

  const submit = useCallback(async (value: string) => {
    if (!value) return modal.exit();
    const res = await password(id, value);
    if (res && res.result === 'Success') {
      toast.show(t`Updated password to “${name}”`);
    } else {
      toast.show(res?.message ?? t`Failed to update password to “${name}”`, {type: 'danger'});
    }
    modal.exit();
  }, [id]);

  const clear = useCallback(async () => {
    const res = await password(id, '');
    if (res && res.result === 'Success') {
      toast.show( t`Removed password to “${name}”`);
    } else {
      toast.show(res?.message ?? t`Failed to remove password to “${name}”`, {type: 'danger'});
    }
    modal.exit();
  }, [id]);

  const open = useCallback(() => {
    modal.open(
      <Prompt
        title={t`Password Protect`}
        text={isFolder ? `${name} ${isFolder ? 'folder' : 'file'}` : name}
        options={{
          type: 'secure-text',
          placeholder: t`Password`,
          autoCompleteType: 'password',
        }}
        buttons={[
          {
            mode: 'primary',
            text: t`Save`.toUpperCase(),
            onPress: submit,
          },
          {
            mode: 'destructive',
            text: t`Remove`.toUpperCase(),
            onPress: clear,
          },
          {
            mode: 'cancel',
            text: t`Cancel`.toUpperCase(),
            onPress: modal.exit,
          },
        ]}
      />
    );
  }, []);

  return {open, exit: modal.exit};
}
